var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Calendar, OptionsInput } from '@fullcalendar/core';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import AddEventDialog from '@/components/mi-calendar/AddEventDialog';
import { Settings as LuxonSettings } from 'luxon';
import { addClass, removeClass } from '@/support/Html';
import nlLocale from '@fullcalendar/core/locales/nl';
import i18n from '@/i18n';
let MiCalendar = class MiCalendar extends Vue {
    constructor() {
        super(...arguments);
        this.calendar = null;
        this.calendarId = `calendar_${Math.random().toString(36).substr(2, 9)}`;
        this.calendarOptions = null;
        this.currentLanguage = '';
    }
    mounted() {
        const pageContainer = document.querySelectorAll('.pageContainer')[0];
        addClass(pageContainer, 'pageContainer--hasCalendar');
        const calendarEl = document.getElementById(this.calendarId);
        if (calendarEl) {
            this.createFullCalendar(calendarEl);
        }
    }
    setOptions(options) {
        Object.keys(options).forEach((optionsKey) => {
            this.calendar.setOption(optionsKey, options[optionsKey]);
        });
    }
    getCalendarInfo() {
        if (!this.calendar) {
            return null;
        }
        return this.calendar.view;
    }
    initializeOptions() {
        this.calendarOptions = this.options;
        this.calendarOptions.locale = this.currentLocale === 'nl' ? nlLocale : LuxonSettings.defaultLocale;
        this.calendarOptions.events = [...[], ...this.events];
    }
    beforeDestroy() {
        const pageContainer = document.querySelectorAll('.pageContainer')[0];
        removeClass(pageContainer, 'pageContainer--hasCalendar');
    }
    createFullCalendar(element) {
        this.initializeOptions();
        setTimeout(() => {
            this.calendar = new Calendar(element, this.calendarOptions || {});
            this.calendar.render();
        }, 100);
    }
    setLocale(language) {
        if (!this.calendar) {
            return;
        }
        this.calendar.setOption('locale', language);
    }
    rerenderFullCalendar() {
        // TODO: implement
    }
    clearEvents() {
        if (!this.calendar) {
            return;
        }
        const sources = this.calendar.getEventSources();
        sources.forEach((eventSource) => {
            eventSource.remove();
        });
    }
    setEvents() {
        if (!this.calendar) {
            return;
        }
        const mergedEvents = [...this.events, ...this.backgroundEvents];
        this.calendar.addEventSource(mergedEvents);
        this.calendar.render();
    }
    getEvents() {
        if (!this.calendar) {
            return;
        }
        this.calendar.getEvents();
    }
    getEventsById(id) {
        if (!this.calendar) {
            return;
        }
        return this.calendar.getEventById(id);
    }
    get currentLocale() {
        if (!i18n || !i18n.locale) {
            return 'nl';
        }
        return i18n.locale;
    }
    optionsChanged(newOptions) {
        if (!this.calendar) {
            return;
        }
        this.setOptions(newOptions);
    }
    eventsChanged(newEvents) {
        this.clearEvents();
        if (newEvents.length) {
            this.events = newEvents;
            this.setEvents();
        }
    }
    backgroundEventsChanged(newBackgroundEvents) {
        // TODO: implement
        if (newBackgroundEvents.length) {
            this.backgroundEvents = newBackgroundEvents;
            this.clearEvents();
            this.setEvents();
        }
    }
};
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_a = typeof OptionsInput !== "undefined" && OptionsInput) === "function" ? _a : Object)
], MiCalendar.prototype, "options", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], MiCalendar.prototype, "backgroundEvents", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], MiCalendar.prototype, "events", void 0);
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof OptionsInput !== "undefined" && OptionsInput) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], MiCalendar.prototype, "optionsChanged", null);
__decorate([
    Watch('events'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MiCalendar.prototype, "eventsChanged", null);
__decorate([
    Watch('backgroundEvents'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MiCalendar.prototype, "backgroundEventsChanged", null);
MiCalendar = __decorate([
    Component({
        components: {
            AddEventDialog,
        },
    })
], MiCalendar);
export default MiCalendar;
